<template>
  <div v-if="display">
    <strong>
      Your hierarchy (bold values are visualized as bubbles)
    </strong>
    <ul>
      <HierarchyItem
        v-for="item in level1.slice(0,10)"
        :key="item"
        :level1="item"
      />
      <li v-if="level1.length > 10">
        ...
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import HierarchyItem from '@/components/admin/upload/CSVSettings/DefineHierarchy/HierarchyItem.vue'
import { useUploadStore } from '@/store/admin/upload'

const components = {
  HierarchyItem,
}

@Component({ components })
export default class DisplayHierarchy extends Vue {
  upload = useUploadStore()
  get display () {
    return this.upload.levelsHelper.columnForLevel(1) && this.upload.hasRows
  }

  get level1 () {
    return this.upload.levelValues(1)
  }
}

</script>
